import React from "react";
import {
  Box,
  Card,
  Container,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import Layout from "../components/Layout/Layout";
import { APP_TITLE } from "../constants/title";
import { Helmet } from "react-helmet";
import LpCategories from "../components/LpCategories/LpCategories";
import LpCollectionOfExamples from "../components/LpCollectionOfExamples/LpCollectionOfExamples";

const useStyles = makeStyles((theme) => ({
  title: {
    textAlign: "center",
    fontSize: 36,
    fontWeight: 800,
    color: "#000",
    lineHeight: 1.15,
    [theme.breakpoints.up("md")]: {
      fontSize: 58,
    },
  },
  image: {
    borderRadius: "50%",
    width: 180,
  },
  name: {
    marginTop: theme.spacing(2),
    textAlign: "center",
    fontSize: 24,
    fontWeight: 500,
    color: "#000",
    lineHeight: 1.25,
    marginBottom: theme.spacing(2),
  },
}));

const AboutUsView = () => {
  const classes = useStyles();

  return (
    <>
      <Layout title={"O Fífovi"}>
        <Container maxWidth={"lg"} className={"landingPageView"}>
          <Grid
            container
            spacing={2}
            style={{ marginTop: 8, marginBottom: 16, alignItems: "center" }}
            className={"landingPageView"}
          >
            <Grid item xs={12} md={6}>
              <Typography variant={"h1"}>
                Jsem Fífa a účetnictví vysvětluju líp než Babiš na tiskovce
              </Typography>
              <Typography>
                Jsem Fífa a účto už jsem vysvětlil tolika studentům, že bych
                mohl dělat audit i finančáku. Dřív jsem doučoval jen osobně, ale
                pak mi došlo, že nemůžu zachraňovat každýho, kdo si myslí, že
                aktiva jsou něco do posilky a pasiva znamenaj, že se nemusí
                snažit. Tak jsem rozjel Videonalejvárny.cz – online doučování,
                kde si pustíš účto kdykoliv, třeba i ve dvě ráno, když ti dojde,
                že jedinej součet, co zvládáš, je na účtence z hospody. 📊🫠
              </Typography>
              <Typography>
                Za ty roky mi prošlo rukama přes 10 000 studentů, co se snažili
                přežít účto, ekonomii a další předměty, co ti spolehlivě zničí
                duševní zdraví. Na webu najdeš přes 1200 videí, stovky recenzí a
                hromadu lidí, co se mnou přežili účto i státnice. Takže jestli
                nechceš u zkoušky vypadat jak státní rozpočet po Babišovi, hoď
                si Videonalejvárny a pojď to dát. 🚀📉
              </Typography>
              <Typography>
                (Pozn.: Jestli tě účetnictví nebaví, doporučuju kombinovat moje
                videa s pivem nebo brkem. Po obojím to údajně dává větší smysl.
                🍺🌿)
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} style={{ textAlign: "center" }}>
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/kY7RKUgHjbI?si=JSwrtSq3t1jwbpfa"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            style={{ marginTop: 8, marginBottom: 16, alignItems: "center" }}
            className={"landingPageView"}
          >
            <Grid item xs={12}>
              <Typography variant={"h2"}>Fífovo socky </Typography>
            </Grid>
            <Grid item xs={12} lg={8}>
              <a
                href={"https://www.facebook.com/accountingfifa/reviews"}
                target={"_blank"}
                rel="noreferrer"
              >
                <img src={"/fifa_fb.png"} alt={"Facebook"} height={327} />
              </a>
            </Grid>
            <Grid item xs={12} lg={4}>
              <a
                href={"https://www.instagram.com/videonalejvarny_prg/"}
                target={"_blank"}
                rel="noreferrer"
              >
                <img src={"/fifa_ig.jpg"} alt={"Instagram"} height={527} />
              </a>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            style={{ marginTop: 8, marginBottom: 16, alignItems: "center" }}
          >
            <Grid item xs={12}>
              <Typography variant={"h2"}>
                Přes 1200 videí s doučováním. Vyber si předmět
              </Typography>
              <Typography>
                Ve videích máš všechno hezky po kapitolách, vypočítaný příklady
                a komplet nalejvárny na závěrečný testy i státnice. Žádný
                složitosti, prostě to, co musíš umět, abys prošel a nemusel
                prodávat ledvinu. A kdyby ti to bylo málo, sepsal jsem i svoje
                vlastní sbírky příkladů – ideální, když si chceš potrénovat a u
                testu nevypadat jak jelen před dálkovejma.
              </Typography>

              <LpCategories />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            style={{ marginTop: 8, marginBottom: 16, alignItems: "center" }}
          >
            <Grid item xs={12}>
              <Typography variant={"h2"}>
                Napsal jsem vlastní sbírky příkladů
              </Typography>
              <Typography>
                Napsal jsem vlastní sbírky příkladů, protože ty oficiální jsou
                tak strašný, že bych je pochopil spíš po třech brkách než po
                třech hodinách studia. 🌿🤡 A taky už mě nebavilo furt dokola
                vysvětlovat, že aktiva nejsou protein a že pasiva neznamenaj, že
                se můžeš flákat. Takže teď máš příklady, co konečně dávaj smysl,
                nejsou suchý jak lednice v neděli ráno po tahu, a hlavně tě fakt
                připraví na test. 🚀📊
              </Typography>

              <LpCollectionOfExamples />
            </Grid>
          </Grid>
        </Container>
      </Layout>
    </>
  );
};

export default AboutUsView;
